import { Globe, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/lib/i18n";

export default function LanguageSwitcher() {
  const { lang, setLang, languages } = useI18n();
  const current = languages.find((l) => l.code === lang) || languages[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="text-slate-500 hover:text-blue-600 gap-1.5" data-testid="language-switcher" title={current.native}>
          <Globe className="h-4 w-4" />
          <span className="hidden md:inline text-xs font-semibold">{current.native}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44" data-testid="language-menu">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            data-testid={`language-option-${l.code}`}
            className="gap-2 cursor-pointer"
          >
            <span className="flex-1">{l.native}</span>
            <span className="text-[10px] text-slate-400">{l.label}</span>
            {lang === l.code && <Check className="h-3.5 w-3.5 text-blue-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
